module.exports = __webpack_public_path__ + "img/icon-lock_green.1d202f09.svg";